import Link from 'next/link';
import React from 'react';
import OnlineStatusIndicator from '@/components/atoms/OnlineStatusIndicator';

interface NotificationConfig {
  notificationText: string;
  notificationCTA: {
    text: string;
    href: string;
  };
}

interface NotificationBarProps {
  isVisible: boolean;
  config: NotificationConfig;
}

const NotificationBar = ({ isVisible, config }: NotificationBarProps) => {
  return (
    <>
      {/* Desktop Notification Bar */}
      <div
        className={`hidden lg:flex fixed top-0 w-full z-50 bg-transparent text-[#191919] items-center justify-between text-[14px] h-10 px-10 py-2 transition-opacity duration-300 ${
          isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
      >
        <Link href={config.notificationCTA.href} className="">
          <div className="flex items-center gap-x-2">
            <OnlineStatusIndicator />
            <span>{config.notificationText}</span>
          </div>
        </Link>
        <Link href={config.notificationCTA.href} className="">
          <span>{config.notificationCTA.text}</span>
        </Link>
      </div>

      {/* Mobile Notification Bar */}
      <Link href={config.notificationCTA.href} passHref legacyBehavior>
        <a
          className={`lg:hidden fixed bottom-0 border-[#c8c8c8]/25 border border-solid left-5 right-5 z-50 rounded-xl bg-white/90 p-3 text-center text-sm text-black shadow-lg backdrop-blur-sm transition-all duration-300 ${
            isVisible
              ? 'opacity-100 translate-y-0'
              : 'opacity-0 translate-y-10 pointer-events-none'
          }`}
        >
          {config.notificationText}
        </a>
      </Link>
    </>
  );
};

export default NotificationBar; 